import React from "react";

interface EmptyStateProps {
  icon?: string | React.ReactNode;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-8 text-center min-h-[300px]">
      <div className="text-6xl mb-6 opacity-50 dark:opacity-30">{icon}</div>
      <h3 className="text-2xl font-semibold text-white dark:text-[var(--text-color)] mb-2">{title}</h3>
      <p className="text-base text-muted mb-8 max-w-[400px] leading-relaxed">{description}</p>
      {actionLabel && onAction && (
        <button 
          onClick={onAction} 
          className="px-6 py-3 bg-primary text-white border-none rounded-lg text-base font-semibold cursor-pointer transition-all hover:bg-primary-dark hover:-translate-y-0.5 hover:shadow-lg hover:shadow-primary/30 active:translate-y-0"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;